<template>
	<app-section class="flex flex-1 flex-col mt-2 tight overflow-x-auto overflow-y-hidden">
		<div class="flex flex-row">
			<app-title title="Orders" class="small" />
			<app-button
				icon="download"
				class="btn btn-primary transparent small ml-2"
				@click="exportOrders"
				:loading="exporting"
			/>
		</div>
		<orders-table :orders="orders" :disabled="true" />
		<app-pagination
			:filters="filters"
			@prevPage="prevPage"
			@nextPage="nextPage"
			@limitChange="changeLimit"
			:loading="loading"
		/>
	</app-section>
</template>

<script>
	import OrdersTable from '@/components/orders/OrdersTable';
	import OrderService from '@/services/OrderService';
	import AppPagination from '@/components/app/AppPagination';

	export default {
		name: 'DiscountOrders',
		components: {
			OrdersTable,
			AppPagination,
		},
		props: {
			discountId: {
				required: true,
				type: [String, Number],
			},
			businessIDs: {
				required: true,
			},
			reload: {},
		},
		data: () => ({
			loading: false,
			orders: [],
			filters: {
				limit: 50,
				offset: 0,
			},
			exporting: false,
		}),
		methods: {
			getOrders() {
				this.loading = true;
				OrderService.list({
					...this.filters,
					discountId: this.discountId,
					businessIDs: this.businessIDs.join('-'),
				})
					.then((orders) => {
						this.orders = orders;
					})
					.catch((error) => {
						this.$notificationService.error(error);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			exportOrders() {
				this.exporting = true;
				OrderService.export({
					...this.filters,
					discountId: this.discountId,
				}).finally(() => {
					this.exporting = false;
				});
			},
			prevPage() {
				this.filters.offset = Math.max(this.filters.offset - this.filters.limit, 0);
				this.getOrders();
			},
			nextPage() {
				this.filters.offset = this.filters.offset + this.filters.limit;
				this.getOrders();
			},
			changeLimit(value) {
				this.filters = {
					...this.filters,
					limit: value,
					offset: 0,
				};
				this.getOrders();
			},
		},
		mounted() {
			this.getOrders();
		},
		watch: {
			reload() {
				this.getOrders();
			},
		},
	};
</script>
